import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b8b8b88"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "me-3" }, "Công ty: ...........................................", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Chi nhánh: ...........................................", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bolder text-uppercase" }, " Bảng kê chi tiết xuất theo đối tượng ", -1))
const _hoisted_4 = {
  class: "text-center mb-3 fst-italic",
  style: {"font-size":"0.8rem"}
}
const _hoisted_5 = {
  class: "text-center mb-0",
  style: {"font-size":"0.9rem"}
}
const _hoisted_6 = {
  class: "text-center",
  style: {"font-size":"0.9rem"}
}
const _hoisted_7 = { class: "mx-2" }
const _hoisted_8 = { class: "mx-2" }
const _hoisted_9 = { class: "mx-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-end mb-0 fst-italic",
  style: {"font-size":"0.8rem"}
}, "ĐVT: đồng", -1))
const _hoisted_11 = {
  class: "d-flex justify-content-between mx-5 align-items-end",
  style: {"font-size":"0.8rem"}
}
const _hoisted_12 = { class: "flex flex-column justify-content-end align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-center my-2 fst-italic",
  style: {"font-size":"0.8rem"}
}, " Ngày ..... tháng ..... năm ..... ", -1))

import { PropType, getCurrentInstance, ref, computed } from 'vue';
import {
  ICapSuaChuaResponseBase,
  IChiTietXuatTheoDoiTuongResponseBase,
  IKhoResponseBase,
  IToaXeResponseBase
} from '@/core/interfaces/ApiResponses';
import { ButtonsType } from '@/core/enums/buttons.enums';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import ChiTietXuatTheoDoiTuongTable from '../table-components/ChiTietXuatTheoDoiTuongTable.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import SignatureCol from '@/layout/_shared/SignatureCol.vue';

const modalId = 'modal-id-print-modal';


export default /*#__PURE__*/_defineComponent({
  __name: 'KeHoachChiPhiPrintModal',
  props: {
  capSuaChua: {
    type: Object as PropType<ICapSuaChuaResponseBase | null>,
    default: null,
  },
  from: {
    type: Date,
    default: new Date(),
  },
  items: {
    type: Array as PropType<IChiTietXuatTheoDoiTuongResponseBase[]>,
    default: () => ([]),
  },
  kho: {
    type: Object as PropType<IKhoResponseBase | null>,
    default: null,
  },
  to: {
    type: Date,
    default: new Date(),
  },
  toaXe: {
    type: Object as PropType<IToaXeResponseBase | null>,
    default: null,
  },
},
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const app = getCurrentInstance();

const onPrintingButtonClicked = () => {
  (app.appContext.config.globalProperties as any).$htmlToPaper(modalId);
}

const isOpen = ref(false);

__expose({
  isOpen,
});

const dateDisplay = computed(() => {
  if (props.from.getTime() === props.to.getTime()) return `Vào xưởng ngày ${props.from.getDate()} tháng ${props.from.getMonth() + 1} năm ${props.from.getFullYear()}`;

  return `Vào xưởng ngày ${props.from.getDate()} tháng ${props.from.getMonth() + 1} năm ${props.from.getFullYear()} Ra xưởng ngày ${props.to.getDate()} tháng ${props.to.getMonth() + 1} năm ${props.to.getFullYear()}`
});

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    title: "Bảng kê chi tiết xuất theo đối tượng",
    width: "90%",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(DivRow, { class: "mb-2" }, {
        default: _withCtx(() => [
          _createVNode(DivCol, { cols: 10 }),
          _createVNode(DivCol, {
            cols: 2,
            class: "text-end justify-content-end"
          }, {
            default: _withCtx(() => [
              _createVNode(ButtonCustom, {
                "button-type": _unref(ButtonsType).FA_PRINT,
                onClick: onPrintingButtonClicked
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("In phiếu")
                ]),
                _: 1
              }, 8, ["button-type"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        id: modalId,
        class: "printing-paper"
      }, [
        _createVNode(DivRow, { class: "row mb-2" }, {
          default: _withCtx(() => [
            _createVNode(DivCol, {
              cols: 10,
              style: {"font-size":"0.8rem","font-weight":"700"}
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(DivRow, { class: "row mb-3" }, {
          default: _withCtx(() => [
            _createVNode(DivCol, { cols: 3 }),
            _createVNode(DivCol, { cols: 6 }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("p", _hoisted_4, _toDisplayString(dateDisplay.value), 1),
                _createElementVNode("p", _hoisted_5, "Xuất tại kho: " + _toDisplayString(__props.kho?.ten_kho), 1)
              ]),
              _: 1
            }),
            _createVNode(DivCol, { cols: 3 })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, "Tên đối tượng: " + _toDisplayString(__props.toaXe?.ten_toa_xe), 1),
          _createElementVNode("span", _hoisted_8, "Mã đối tượng: " + _toDisplayString(__props.toaXe?.ma_toa_xe), 1),
          _createElementVNode("span", _hoisted_9, "Cấp sửa chữa: " + _toDisplayString(__props.capSuaChua?.ten_cap_sc), 1)
        ]),
        _hoisted_10,
        _createVNode(DivRow, null, {
          default: _withCtx(() => [
            _createVNode(DivCol, { cols: 12 }, {
              default: _withCtx(() => [
                _createVNode(ChiTietXuatTheoDoiTuongTable, { items: __props.items }, null, 8, ["items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _createVNode(SignatureCol, { "nguoi-ky": "Thủ kho" })
          ]),
          _createElementVNode("div", null, [
            _createVNode(SignatureCol, { "nguoi-ky": "Người giữ sổ" })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(SignatureCol, { "nguoi-ky": "TP Tài Chính" })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})